<template>
  <v-app full-height>
    <VLocaleProvider rtl>
      <NotificationsSnackBar/>
      <NuxtPage v-if="!loading"/>
      <ShareLoading v-if="loading"/>
    </VLocaleProvider>
  </v-app>
</template>


<script setup>

const loading = ref(true);

onMounted(async () => {
  await nextTick();
  loading.value = false;
});

</script>

<style>
.text-body-1, .text-body-2, .text-caption {
  letter-spacing: 0 !important;
}
</style>